import { createBuilderModule } from '../../builder';
import { HubSpotMeeting } from './HubSpotMeeting';

export default createBuilderModule(HubSpotMeeting, {
  name: 'HubSpotMeeting',
  image: 'https://cdn.zappy.app/19296724b95dd418fac6abdcfce5c084.png',
  inputs: [
    {
      type: 'string',
      name: 'dataSource',
      helperText:
        "The 'data-src' property from the embed code taken from HubSpot. Details: https://knowledge.hubspot.com/meetings-tool/embed-the-meeting-widget-on-a-page",
      defaultValue:
        'https://meetings.hubspot.com/beth-rea2/product-advocate-meetings?embed=true',
    },
  ],
});
